import { render } from "./dashboard-page.vue?vue&type=template&id=690a87df"
import script from "./dashboard-page.vue?vue&type=script&lang=js"
export * from "./dashboard-page.vue?vue&type=script&lang=js"

import "./dashboard-page.vue?vue&type=style&index=0&id=690a87df&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__